<template>
    <!--客户案例-->
    <div class="customerCase">
        <div class="banner"  @click="tabShow1">
            <div class="banner_text">
                <div class="banner_text_title">客户案例</div>
                <div class="banner_text_pgh">
                    <span>C</span>ustomer Cases
                </div>
            </div>
            <div class="banner_img_pc">
                <img src="@/asstes/customerCase/banner.png">
            </div>
            <div class="banner_img_app">
                <img src="@/asstes/customerCase/banner_app.png">
            </div>
        </div>
        <div class="customerCase_tab_pc">
            <div class="customerCase_tab_item" v-for="(item, index) in tabList" :key="index">
                <div class="customerCase_tab_title"
                     :class="{'active': item.value == accountActive}"
                     @click="accountActive = item.value"
                     @mouseover="mouseOver(item.value)">{{ item.title }}</div>
            </div>
        </div>
        <div class="customerCase_tab_app">
<!--            <el-select v-model="value" placeholder="请选择">-->
<!--                <el-option v-for="item in tabList" :key="item.value" :label="item.title" :value="item.value">-->
<!--                </el-option>-->
<!--            </el-select>-->
            <div class="tab_list">
                <div class="tab_name" @click="tabShow">
                    <span>{{ value }}</span>
                    <img src="@/asstes/customerCase/down.png" style="padding-left: 8px; width: 5% ">
                </div>
                <div class="tabList_item" v-show="tablistShow">
                    <div class="tab_item" v-for="(item, index) in tabList" :key="index">
                        <div class="tab_title"
                             :class="{'active': item.value == choseActive}"
                             @click="handleChose(item.title, item.value)">{{ item.title }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="customerCase_info"  @click="tabShow1">
            <!--私桩安装运维服务平台系统-->
            <div class="first" v-show="firstShow">
                <div class="info_first">
                    <div class="info_first_img">
                        <img src="@/asstes/customerCase/first/001.png">
                    </div>
                    <div class="info_first_info">
                        <div class="first_info_title">国网电动：“一横五纵”工业互联网平台监理开发</div>
                        <div class="first_info_pgh">围绕社区充电建设“一横五纵”的工业互联网平台，建立统一技术标准，构建支撑“用户商城、生产监造、安装监理、运维服务、充电运营”的平台架构，整合设备制造商、渠道经销商、安装服务商、运维服务商等产业链资源，全面推动社区有序充电发展。</div>
                    </div>
                </div>
                <div class="second_app info_first">
                    <div class="info_first_img">
                        <img src="@/asstes/customerCase/first/002.png">
                    </div>
                    <div class="info_first_info">
                        <div class="first_info_title">为 3 家车企提供了充电桩安装的SaaS服务<br/>为 5 家车企定制开发了充电桩安装管理系统</div>
                        <div class="first_info_pgh">
                            提供实时、可视化的充电桩监控管理与运营服务；为用户、运营商与安装商实现充电桩安装的移动管理；提升工作效率，促进用户沟通；
                        </div>
                    </div>

                </div>
                <div class="info_second">
                    <div class="info_second_info">
                        <div class="second_info_title">为 3 家车企提供了充电桩安装的SaaS服务；<br/>为 5 家车企定制开发了充电桩安装管理系统；</div>
                        <div class="second_info_pgh">
                            提供实时、可视化的充电桩监控管理与运营服务；为用户、运营商与安装商实现充电桩安装的移动管理；提升工作效率，促进用户沟通；
                        </div>
                    </div>
                    <div class="info_second_img">
                        <img src="@/asstes/customerCase/first/002.png">
                    </div>
                </div>
            </div>
            <!--换电运营车管理系统-->
            <div class="first" v-show="fourthShow">
                <div class="info_first">
                    <div class="info_first_img">
                        <img src="@/asstes/customerCase/fourth/001.png">
                    </div>
                    <div class="info_first_info">
                        <div class="first_info_title">国家电投：融合新能源电动集卡平台</div>
                        <div class="first_info_pgh">
                            通过智能硬件 + 监控平台的模式，赋能换电重卡，具备网联化的能力，实现车辆资产的智能化管理和车辆智能化调度管理。通过车联网系统可支持与第三方调度系统、订单系统、换电监控系统的对接，从而实现业务场景的闭环。实现接入重卡的实时车况、充电、行驶数据的监测。同时，提供远程调试和地图升级等辅助功能。根据当日采集的行驶数据分析车辆能耗水平，为车辆运营提供决策依据。
                        </div>
                    </div>
                </div>
                <div class="second_app info_first">
                    <div class="info_first_img">
                        <img src="@/asstes/customerCase/fourth/002.png">
                    </div>
                    <div class="info_first_info">
                        <div class="first_info_title">吉利：万物友好智能网联运营管理平台项目</div>
                        <div class="first_info_pgh">
                            打造资产管控平台以获得的基础数据构建智能分析模型，实现车辆、换电站等资产智能排班调度管理。进一步保证安全生产，避免人为因素造成的安全事故；大幅度降低管理人力投入，降低运营成本；实现24小时无人化作业，提高运营效率。最终实现业务管理全面覆盖，数据开放对接，用户服务方便快捷，助力吉利绿运产业快速发展。
                        </div>
                    </div>
                </div>

                <div class="info_second">
                    <div class="info_second_info">
                        <div class="second_info_title">吉利：万物友好智能网联运营管理平台项目</div>
                        <div class="second_info_pgh">
                            打造资产管控平台以获得的基础数据构建智能分析模型，实现车辆、换电站等资产智能排班调度管理。进一步保证安全生产，避免人为因素造成的安全事故；大幅度降低管理人力投入，降低运营成本；实现24小时无人化作业，提高运营效率。最终实现业务管理全面覆盖，数据开放对接，用户服务方便快捷，助力吉利绿运产业快速发展。
                        </div>
                    </div>
                    <div class="info_second_img">
                        <img src="@/asstes/customerCase/fourth/002.png">
                    </div>
                </div>
            </div>

            <!--私桩共享运营服务平台系统-->
            <div class="second" v-show="secondShow">
                <div class="customerCase_info_img">
                    <div class="info_img_first">
                        <img src="@/asstes/customerCase/zdj.png" style="width: 60%;">
                    </div>
                    <div class="info_img_second">
                        <img src="@/asstes/customerCase/background.png" style="width: 100%">
                    </div>
                </div>
                <div class="customerCase_info_info">
                    <div class="customerCase_info_info_title">私桩共享运营服务平台系统</div>
                    <div class="customerCase_info_info_pgh">
                        为多家企业提供代管服务，共接入约600根充电桩；<br/>为多家车企提供桩联网服务，接入超过100000+充电桩；<br/>约400个社区，约9000+个充电桩；<br/>进一步提升充电便利性，为用户带来更多的纯电动出行体验，整体人、车、桩、网一体化的可持续利用能源生态。
                    </div>
                </div>
            </div>

            <!--目的地充电平台系统-->
            <div class="third" v-show="thirdShow">
                <div class="info_third">
                    <div class="info_third_img">
                        <img src="@/asstes/customerCase/third/001.png">
                        <img src="@/asstes/customerCase/third/002.png">
                    </div>
                    <div class="info_third_info">
                        <div class="third_info_title">目的地充电平台系统</div>
                        <div class="third_info_pgh">
                            软硬一体”解决方案匹配不同充电服务场景；<br/>智能硬件 + 平台服务赋能充电站-桩-电动汽车实现数智化管理和运营；<br/>为园区、政府、地产等提供充电桩安装及运维服务、内外部车辆充电运营服务 。
                        </div>
                    </div>
                </div>
            </div>
            <!--分时租赁平台系统-->
            <div class="third" v-show="seventhShow">
                <div class="info_third">
                    <div class="info_third_img">
                        <img src="@/asstes/customerCase/seventh/001.png">
                        <img src="@/asstes/customerCase/seventh/002.png">
                    </div>
                    <div class="info_third_info">
                        <div class="third_info_title">分时租赁平台系统</div>
                        <div class="third_info_pgh">
                            打造了 2 个电动汽车分时租赁运营样板工程；<br/>
                            实现去门店化，无人值守。无需人工交接钥匙，自助式服务；<br/>
                            提供信息化、网络化、智能化的综合用车服务；<br/>
                            实现电动汽车资源的高效调配，降低闲置率。<br/>
                            基于物联网技术和先进的运营模式实现随地取还车的出行方式，通过使用新能源汽车，提升用户短途出行效率，减少碳排放，构建美好的出行体验。
                        </div>
                    </div>
                </div>
            </div>

            <!--分布式储能电站运营管理系统-->
            <div class="fifth" v-show="fifthShow">
                <div class="info_fifth">
                    <div class="info_fifth_img">
                        <img src="@/asstes/customerCase/fifth/001.png">
                    </div>
                    <div class="info_fifth_info">
                        <div class="fifth_info_title">分布式储能电站运营管理系统</div>
                        <div class="fifth_info_pgh">
                            为国家电投定制开发了能源管理系统，通过信息化手段提效降本。<br/>为全球最大的锂材料供应商杉杉股份定制开发了储能运营管理平台。<br/>全面加强对设备的掌控力度；节省大量成本支出；使得维保过程规范化，不断提高管理效率；提高用户满意度，增强产品的销售粘性。
                        </div>
                    </div>
                </div>
            </div>
            <!--绿色出行平台系统-->
            <div class="fifth" v-show="sixthShow">
                <div class="info_fifth">
                    <div class="info_fifth_img">
                        <img src="@/asstes/customerCase/sixth/001.png">
                    </div>
                    <div class="info_fifth_info">
                        <div class="fifth_info_title">绿色出行平台系统</div>
                        <div class="fifth_info_pgh">
                            无锡挚达结合平湖市的实际情况，运用车桩位人四位一体的先进技术和运营经验，作为新业态的创新应用；成功搭建达到平湖市主要的具有影响力和公信力的超级充电平台和App。<br/>
                            散落的充电桩“一网通联”，实现了车主、企业、政府的三赢——让身处“应用端”的用户充电更方便，以“透明价”规范充电桩运营商市场行为，在“治理端”为政府监管提供数据支撑。
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                accountActive: '1',
                value: '私桩共享运营服务平台系统',
                choseActive: '1',
                tabList:[
                    {
                        value:'0',
                        title: '私桩安装运维服务平台系统'
                    },
                    {
                        value: '1',
                        title: '私桩共享运营服务平台系统'
                    },
                    {
                        value: '2',
                        title: '目的地充电平台系统'
                    },
                    {
                        value: '3',
                        title: '换电运营车管理系统'
                    },
                    {
                        value: '4',
                        title: '分布式储能电站运营管理系统'
                    },
                    {
                        value: '5',
                        title: '绿色出行平台系统'
                    },
                    {
                        value: '6',
                        title: '分时租赁平台系统'
                    }
                ],
                tablistShow: false,
                firstShow: false,
                secondShow: true,
                thirdShow: false,
                fourthShow: false,
                fifthShow: false,
                sixthShow: false,
                seventhShow: false,
            }
        },
        methods:{
            tabShow(){
                let that = this;
                that.tablistShow = !that.tablistShow
            },
            tabShow1(){
                let that = this;
                that.tablistShow = false
            },
            handleChose(val, num){
                let that = this;
                that.tablistShow = false
                that.value = val;
                that.choseActive = num;
                if( num == 0 ){
                    that.firstShow = true;
                    that.secondShow = false;
                    that.thirdShow = false;
                    that.fourthShow = false;
                    that.fifthShow = false;
                    that.sixthShow = false;
                    that.seventhShow = false;
                }
                if( num == 1 ){
                    that.firstShow = false;
                    that.secondShow = true;
                    that.thirdShow = false;
                    that.fourthShow = false;
                    that.fifthShow = false;
                    that.sixthShow = false;
                    that.seventhShow = false;
                }
                if( num == 2 ){
                    that.firstShow = false;
                    that.secondShow = false;
                    that.thirdShow = true;
                    that.fourthShow = false;
                    that.fifthShow = false;
                    that.sixthShow = false;
                    that.seventhShow = false;
                }
                if( num == 3 ){
                    that.firstShow = false;
                    that.secondShow = false;
                    that.thirdShow = false;
                    that.fourthShow = true;
                    that.fifthShow = false;
                    that.sixthShow = false;
                    that.seventhShow = false;
                }
                if( num == 4 ){
                    that.firstShow = false;
                    that.secondShow = false;
                    that.thirdShow = false;
                    that.fourthShow = false;
                    that.fifthShow = true;
                    that.sixthShow = false;
                    that.seventhShow = false;
                }
                if( num == 5 ){
                    that.firstShow = false;
                    that.secondShow = false;
                    that.thirdShow = false;
                    that.fourthShow = false;
                    that.fifthShow = false;
                    that.sixthShow = true;
                    that.seventhShow = false;
                }
                if( num == 6 ){
                    that.firstShow = false;
                    that.secondShow = false;
                    that.thirdShow = false;
                    that.fourthShow = false;
                    that.fifthShow = false;
                    that.sixthShow = false;
                    that.seventhShow = true;
                }
            },
            mouseOver(val){
                let that = this;
                that.accountActive = val;
                if( val == 0 ){
                    that.firstShow = true;
                    that.secondShow = false;
                    that.thirdShow = false;
                    that.fourthShow = false;
                    that.fifthShow = false;
                    that.sixthShow = false;
                    that.seventhShow = false;
                }
                if( val == 1 ){
                    that.firstShow = false;
                    that.secondShow = true;
                    that.thirdShow = false;
                    that.fourthShow = false;
                    that.fifthShow = false;
                    that.sixthShow = false;
                    that.seventhShow = false;
                }
                if( val == 2 ){
                    that.firstShow = false;
                    that.secondShow = false;
                    that.thirdShow = true;
                    that.fourthShow = false;
                    that.fifthShow = false;
                    that.sixthShow = false;
                    that.seventhShow = false;
                }
                if( val == 3 ){
                    that.firstShow = false;
                    that.secondShow = false;
                    that.thirdShow = false;
                    that.fourthShow = true;
                    that.fifthShow = false;
                    that.sixthShow = false;
                    that.seventhShow = false;
                }
                if( val == 4 ){
                    that.firstShow = false;
                    that.secondShow = false;
                    that.thirdShow = false;
                    that.fourthShow = false;
                    that.fifthShow = true;
                    that.sixthShow = false;
                    that.seventhShow = false;
                }
                if( val == 5 ){
                    that.firstShow = false;
                    that.secondShow = false;
                    that.thirdShow = false;
                    that.fourthShow = false;
                    that.fifthShow = false;
                    that.sixthShow = true;
                    that.seventhShow = false;
                }
                if( val == 6 ){
                    that.firstShow = false;
                    that.secondShow = false;
                    that.thirdShow = false;
                    that.fourthShow = false;
                    that.fifthShow = false;
                    that.sixthShow = false;
                    that.seventhShow = true;
                }
            }
        }
    }
</script>

<style lang="less" scoped>

    @media only screen and (max-width: 750px){
        .customerCase{
            .banner{
                margin-top: -220px;
                position: relative;

                .banner_text{
                    position: absolute;
                    top: 756px;
                    left: 162px;
                    color: #353856;
                    .banner_text_title{
                        font-size: 84px;
                        font-weight: 600;
                        line-height: 120px;
                        padding-bottom: 48px;
                        box-sizing: border-box;
                    }
                    .banner_text_pgh{
                        font-size: 57.6px;
                        font-weight: 600;
                        line-height: 46px;

                        span{
                            font-size: 86.4px;
                        }
                    }
                }

                .banner_img_pc{
                    display: none;
                }
                .banner_img_app{
                    img{
                        width: 100%;
                    }
                }

            }

            .customerCase_tab_pc{
                display: none;
            }
            .customerCase_tab_app{
                padding:  216px 144px;
                box-sizing: border-box;
                text-align: center;
                .tab_list{
                    position: relative;
                    font-size: 56px;
                    color: #373A5A;

                    .tab_name{
                        background: #FFFFFF;
                        box-shadow: 0px 2px 36px 5px rgba(180, 191, 198, 0.33);
                        border-radius: 180px;
                        padding: 56px 16px;
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .tabList_item{
                        position: absolute;
                        width: 100%;
                        top: 190px;
                        z-index: 120;
                        padding: 56px 0;
                        background: #FFFFFF;
                        box-shadow: 0px 2px 36px 5px rgba(180, 191, 198, 0.33);
                        border-radius: 60px;

                        .tab_item{
                            padding: 24px 0 40px 0;
                        }
                        .active{
                             color: #00D1B0;
                         }
                    }


                }

            }

            .customerCase_info{
                padding:  216px 144px 216px 144px;
                box-sizing: border-box;

                .first{
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;

                    .info_first{
                        .info_first_img{
                            img{
                                width: 100%;
                            }
                        }
                        .info_first_info{
                            padding-top: 180px;
                            box-sizing: border-box;

                            .first_info_title{
                                text-align: center;
                                font-weight: 600;
                                color: #373A5A;
                                font-size: 79.2px;
                                padding-bottom: 86.4px;
                                box-sizing: border-box;
                            }
                            .first_info_pgh{
                                text-align: left;
                                font-size: 50.4px;
                                line-height: 90px;
                                padding-bottom: 88px;
                                box-sizing: border-box;
                            }
                        }
                    }
                    .info_second{
                        display: none;
                    }
                }

                .second{
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    .customerCase_info_img{
                        position: relative;
                        .info_img_first{
                            position: absolute;
                            top: 36%;
                            img{
                                width: 100%;
                            }
                        }
                        .info_img_second{
                            img{
                                width: 100%;
                            }
                        }
                    }
                    .customerCase_info_info{
                        padding-top: 180px;
                        box-sizing: border-box;

                        .customerCase_info_info_title{
                            font-weight: 600;
                            color: #373A5A;
                            font-size: 79.2px;
                            padding-bottom: 86.4px;
                            box-sizing: border-box;
                        }

                        .customerCase_info_info_pgh{
                            text-align: left;
                            font-size: 50.4px;
                            line-height: 90px;
                        }
                    }
                }

                .third{
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;

                    .info_third{

                        .info_third_img{
                            img{
                                width: 100%;
                            }
                        }
                        .info_third_info{
                            padding-top: 180px;
                            box-sizing: border-box;

                            .third_info_title{
                                text-align: center;
                                font-weight: 600;
                                color: #373A5A;
                                font-size: 79.2px;
                                padding-bottom: 86.4px;
                                box-sizing: border-box;
                            }
                            .third_info_pgh{
                                text-align: left;
                                font-size: 50.4px;
                                line-height: 90px;
                            }
                        }
                    }
                }

                .fifth{
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    .info_fifth{

                        .info_fifth_img{
                            img{
                                width: 100%;
                            }
                        }
                        .info_fifth_info{
                            padding-top: 180px;
                            box-sizing: border-box;

                            .fifth_info_title{
                                text-align: center;
                                font-weight: 600;
                                color: #373A5A;
                                font-size: 79.2px;
                                padding-bottom: 86.4px;
                                box-sizing: border-box;
                            }
                            .fifth_info_pgh{
                                text-align: left;
                                font-size: 50.4px;
                                line-height: 90px;
                            }
                        }
                    }
                }

            }
        }

    }

    @media only screen and (min-width: 750px) {

        .customerCase {
            margin-top: -48px;
            z-index: 80;

            .banner {
                position: relative;

                .banner_text {
                    position: absolute;
                    top: 50%;
                    left: 104px;
                    margin-top: -50px;
                    color: #353856;

                    .banner_text_title {
                        font-size: 36px;
                        font-weight: 600;
                        line-height: 50px;
                        padding-bottom: 16px;
                        box-sizing: border-box;
                    }

                    .banner_text_pgh {
                        font-size: 24px;
                        font-weight: 600;
                        line-height: 46px;
                    }

                    span:first-child {
                        font-size: 32px;
                    }
                }
                .banner_img_pc{
                    img{
                        width: 100%;
                    }
                }
                .banner_img_app{
                    display: none;
                }
            }

            .customerCase_tab_pc {
                padding: 28px 120px 0 120px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;
                text-align: center;

                .customerCase_tab_item {
                    width: 25%;
                    padding-bottom: 24px;
                    box-sizing: border-box;

                    .customerCase_tab_title {
                        text-align: center;
                        max-width: 220px;
                        font-size: 14px;
                        line-height: 32px;
                        background: #FFFFFF;
                        box-shadow: 0px 1px 18px 3px rgba(180, 191, 198, 0.33);
                        border-radius: 20px;
                    }

                    .customerCase_tab_title:hover {
                        cursor: pointer;
                        background-color: #00D1B0;
                        color: white;
                    }

                    .active {
                        background-color: #00D1B0;
                        color: white;
                    }
                }

            }

            .customerCase_tab_app{
                display: none;
            }

            .customerCase_info {
                padding: 80px 120px;
                box-sizing: border-box;

                .first, .third, .fifth{

                    .info_first, .info_second, .info_third, .info_fifth{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        text-align: center;

                        padding-bottom: 80px;
                        box-sizing: border-box;
                        color: #373A5A;

                        .info_first_img, .info_fifth_img{
                            width: 70%;
                            padding-right: 80px;
                            box-sizing: border-box;
                            img{
                                width: 100%;
                            }
                        }
                        .info_second_img{
                            width: 80%;
                            padding-left: 80px;
                            box-sizing: border-box;
                            img{
                                width: 100%;
                            }
                        }

                        .info_third_img{
                            width: 50%;
                            padding-right: 80px;
                            box-sizing: border-box;
                            img{
                                width: 100%;
                            }
                        }
                        .info_first_info, .info_second_info, .info_third_info, .info_fifth_info{
                            text-align: left;
                            max-width: 540px;

                            .first_info_title, .second_info_title, .third_info_title, .fifth_info_title{
                                font-size: 28px;
                                font-weight: 600;
                                line-height: 50px;
                                padding-bottom: 16px;
                                box-sizing: border-box;
                            }
                            .first_info_pgh, .second_info_pgh, .third_info_pgh, .fifth_info_pgh{
                                font-size: 14px;
                                font-weight: 400;
                                color: #000000;
                                line-height: 38px;
                            }
                        }

                    }

                    .second_app{
                        display: none;
                    }
                }
                .second{
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .customerCase_info_img {
                        width: calc(100% - 500px);
                        padding-right: 88px;
                        box-sizing: border-box;
                        position: relative;

                        .info_img_first {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            z-index: 120;
                            margin-top: -44px;
                            margin-left: -165px;
                        }

                        .info_img_second {
                            z-index: 110;
                        }
                    }
                    .customerCase_info_info {
                        color: #373A5A;
                        max-width: 520px;
                        .customerCase_info_info_title {
                            font-size: 28px;
                            font-weight: 600;
                            line-height: 50px;
                            padding-bottom: 16px;
                            box-sizing: border-box;
                        }

                        .customerCase_info_info_pgh {
                            font-size: 14px;
                            font-weight: 400;
                            color: #000000;
                            line-height: 38px;
                        }
                    }
                }
            }
        }
    }
</style>